module.exports = "<img src=\"assets\\pictures\\logo-ai.png\" class=\"img-Cumstom\" alt=\"Responsive image\">\n<br>\n"